import Cookies from 'js-cookie';

import { CookieValues } from '~types/Cookie.types';

export const CookieHelper = {
  getGaClientId() {
    // кука _ga=GA1.1.695909768.1698161847
    const value = Cookies.get(CookieValues.Ga);
    const result = value?.match(/\d+\.\d+$/);

    return result?.[0];
  },
  getYmClientId() {
    // кука _ym_uid=1747663818505410559
    const value = Cookies.get(CookieValues.YmUID);

    return value || '';
  },
};
